import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {AccessibilityModeButton as Presentation} from './accessibility-mode-button'
import {AccessibilityModeButtonRuntimeProps} from './interfaces'

const mapRuntime = ({
  actions: {setShowAccessibilityMode},
}: DetailsPageAppProps): AccessibilityModeButtonRuntimeProps => ({
  setShowAccessibilityMode,
})

export const AccessibilityModeButton = connect<{}, AccessibilityModeButtonRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
